import React, { type FC } from "react";
import { FormLink } from "@components/AuthFlow/FormLink";
import type { SigninHeaderProps } from "@components/AuthFlow/Signin/contract";
import { withPrefix } from "@tracking/tracking";
import { screenNames } from "clientState/AuthFlow/providers/ScreenProvider";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Body, Flex, Heading } from "@edreamsodigeo/prisma-design-system";

import { useTools } from "../../../tools/useTools";

const { SIGNIN, SIGNUP } = screenNames;
export const SIGNUP_LINK_CLICK_LOGIN_ID = `${SIGNIN}_click:${SIGNUP}`;

const MytripsLoginSigninHeader: FC<SigninHeaderProps> = ({
  onSignupClick,
  trackingPrefix,
}) => {
  const { t } = useTranslation();

  const { isDesktop } = useTools();

  return (
    <Flex
      flexDirection="column"
      mt="minus_3x_big"
      gap={["2x_small", "1x_small"]}
      pb="base"
    >
      {isDesktop && (
        <Heading type="2" weight="medium" textAlign="start" color="neutral.100">
          {t("authentication.signin.title")}
        </Heading>
      )}
      <Flex justifyContent="start" alignItems="start" gap="2x_small">
        <Body color="neutral.90" type="xSmall" textAlign="center">
          {t("authentication.signin.signup.title")}
        </Body>
        <FormLink
          withTextDecoration
          trackingId={withPrefix(SIGNUP_LINK_CLICK_LOGIN_ID, trackingPrefix)}
          onClick={onSignupClick}
        >
          {t("authentication.signin.signup.link")}
        </FormLink>
      </Flex>
    </Flex>
  );
};

export default MytripsLoginSigninHeader;
